/**
 * Screen 1 — Onboarding / Splash.
 *
 * Wordmark + value prop + mode chips + two CTAs. Authed users get bounced to
 * the home screen immediately so the splash never feels like a dead end.
 */

import { auth } from '../auth.js';
import { navigate } from '../router.js';

export function renderOnboarding(root) {
  if (auth.isAuthenticated()) {
    navigate('/');
    return;
  }

  root.innerHTML = `
    <div class="hero violet" style="border-radius:0;padding:46px 20px 34px;">
      <div style="font-family:var(--font-display);font-size:13px;letter-spacing:6px;opacity:0.85;text-align:center;">
        TRIVIANA
      </div>
      <div style="font-family:var(--font-display);font-weight:700;font-size:30px;text-align:center;line-height:1.2;margin-top:18px;">
        Win real money<br>for what you know
      </div>
      <div class="center" style="font-weight:500;opacity:0.85;margin-top:10px;font-size:13.5px;">
        Skill-based trivia. Real cash prizes.
      </div>
    </div>

    <div class="pad">
      <div class="center" style="margin:6px 0 16px;">
        <span class="pill on">Solo</span>
        <span class="pill">1-on-1</span>
        <span class="pill">Group</span>
        <span class="pill">Live</span>
      </div>
      <a href="/signup" data-link class="btn">Get started</a>
      <a href="/login" data-link class="btn ghost">I already have an account</a>
      <div class="center" style="font-size:11px;color:var(--mute);font-weight:500;margin-top:10px;">
        18+ · Play responsibly · Licensed operator
      </div>
    </div>
  `;
}
